import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";

import App from "./App.js";
import CookiesPolicy from "./pages/auth/eula/CookiesPolicy";
import ForgotPassword from "./pages/auth/ForgotPassword.js";
import Login from "./pages/auth/Login.js";
import PrivacyPolicy from "./pages/auth/eula/PrivacyPolicy";
import PrivateRoute from "./PrivateRoute.js";
import React from "react";
import ResetPassword from "./pages/auth/ResetPassword.js";
import Export from "./pages/export/Export.js";
import UsersLicense from "./pages/auth/eula/UsersLicense";
import Backup from "./pages/backup/Backup.js";
import Refresh from "./pages/refresh/Refresh.js";
import LoginGigya from "./pages/auth/LoginGigya.js";
import TemporaryLogin from "./pages/auth/TemporaryLogin.js";
import RegisterGigya from "./pages/auth/RegisterGigya.js";

// react-router-dom v7: <Routes> -> <Routes>, element={<X />} -> element={<X/>},
// `exact` removido (default), <Redirect> -> <Navigate>. Rotas sem `exact` em
// v5 que faziam prefix-match agora precisam de `/*` no final.
export const router = (
  <Router>
    <Routes>
      <Route path="/cookies/*" element={<CookiesPolicy />} />
      <Route path="/userslicense/*" element={<UsersLicense />} />
      <Route path="/privacy/*" element={<PrivacyPolicy />} />
      <Route path="/forgot-password/*" element={<ForgotPassword />} />
      <Route path="/reset-password/*" element={<ResetPassword />} />
      <Route path="/export/*" element={<Export />} />
      <Route path="/backup-and-exit/*" element={<Backup />} />
      <Route path="/hard-refresh/*" element={<Refresh />} />

      <Route path="/loginAntigo" element={<Login />} />
      <Route path="/login" element={<LoginGigya />} />
      <Route path="/primeiro-login" element={<TemporaryLogin />} />
      <Route path="/register-gigya" element={<RegisterGigya />} />
      <Route
        path="/*"
        element={<PrivateRoute element={<App />} route="/" />}
      />
    </Routes>
  </Router>
);
